import { makeObservable, observable, action, reaction } from 'mobx';
import { messageStackState } from "/@/app/states/messageStackState";
import { SectionState } from '/@/app/views/LabTestView/SectionState.js';
import { clearLocalStorage } from './localStorage';
import { userFlowState } from "/@/app/states/userFlowState.js";
import { route } from '/@/app/routes';

export class SectionListState {
    api=null;
    panelId;
    sections = [];
    saveState = "saved";

    constructor(sections, panelId, api) {
	this.api=api;
        this.panelId = panelId;
        for (let section of sections) {
            this.sections.push(new SectionState(section, panelId, this.api));
        }

        makeObservable(this, {
            sections: observable,
            saveState: observable,
            setSaveState: action,
            //
            saveAll: action,
        });

        // computed property won't react on nested states automatically,
        // so do it by hand:
        const searchUnsaved = () => {
            for (let section of this.sections) {
                for (let measurement of section.measurements) {
                    if (measurement.value_is_computed) { continue; }
                    if (measurement.saveState !== "saved") {
                        this.setSaveState("unsaved");
                        return;
                    }
                }
            }
            this.setSaveState("saved");
        }
        // react on each field change
        for (let section of this.sections) {
            for (let measurement of section.measurements) {
                reaction(() => measurement.saveState, () => {
                    searchUnsaved();
                });
            }
        }
        searchUnsaved();  // ensure initial state
    }

    setSaveState(state) {
        this.saveState = state;
    }

    resetUnsaved() {
        clearLocalStorage(this.panelId);
        for (let section of this.sections) {
            for (let measurement of section.measurements) {
                if (measurement.value_is_computed) { continue; }
                measurement.replaceValue(measurement.savedValue);
            }
        }
    }

    saveAll() {
        this.setSaveState("saving");

        let payload = [];
        for (let section of this.sections) {
            for (let measurement of section.measurements) {
                if (measurement.value_is_computed) { continue; }
                const cleanValue = measurement.cleanValueType();
                payload.push({
                    xlsx_id: measurement.xlsxId,
                    value_alternative_units: cleanValue,
                    alternative_units: measurement.value.alternativeUnits,
                });
            }
        }

        this.api.request(`cabinet/panels/${this.panelId}/measurements/`, payload, { method: 'POST', silentStatuses:{
            422: (error) => {
                this.setSaveState("unsaved");
                messageStackState.addMessage({
                    text: "Проверьте что все поля верно заполнены",
                    tags: "error",
                    autoHide: 3000,
                });
                // FIXME set errors to fields in bulk.
                // right now the view is refreshed by re-render, which is wrong.
            },
        }}).then((response) => {
            this.setSaveState("saved");
            // sets statuses in bulk
            for (let section of this.sections) {
                for (let measurement of section.measurements) {
                    if (measurement.value_is_computed) { continue; }
                    measurement.resetToDefaultUnits();
                    measurement.setSavedValue(measurement.value);
                    measurement.setSaveState("saved");
                }
            }
            clearLocalStorage(this.panelId);
            if (response.results_recalculated) {
                messageStackState.addMessage({
                    text: "План продления жизни пересчитан. Обновляем страницу.",
                    tags: "success",
                });
                location.reload();
            }
            if (response.calculate_required) {
                // - this means calculation not allowed, a Subscription required.
                userFlowState.setCalculateRequired({
                    isRequired: true,
                    postponeForLocation: route("/lab-tests/"),
                });
                this.setSaveState("saved");
                messageStackState.addMessage({
                    text: "Данные сохранены. Для пересчёта плана продления жизни приобретите подписку.",
                    tags: "warning",
                });
                // FIXME still reload, because we need to update UserFlowStage for panels.
                location.reload();
            }
        }).catch((error) => {
            // skip. Don't retry.
            this.setSaveState("unsaved");
        });
    }
}
